import {
  getGroupedSettings,
  upsertSettingsByType,
  initializeSettings,
} from 'app/pages/MyautoiqSettingsPage/data/myautoiqSettingsRequestUtils';

const SETTINGS_TYPE = 'NURTURING_JOURNEY_CONFIG';

export const fetchMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
  makeId,
}: {
  manufacturerId: string;
  makeId?: string | null;
}): Promise<any> => {
  return getGroupedSettings({ manufacturerId, makeId, type: SETTINGS_TYPE });
};

export const saveMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
  makeId,
  payload,
}: {
  manufacturerId: string;
  makeId?: string | null;
  payload: any;
}): Promise<any> => {
  return upsertSettingsByType({
    manufacturerId,
    makeId,
    type: SETTINGS_TYPE,
    data: payload,
  });
};

export const initializeMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
  makeId,
}: {
  manufacturerId: string;
  makeId?: string | null;
}): Promise<any> => {
  return initializeSettings({ manufacturerId, makeId, type: SETTINGS_TYPE });
};
